import React from 'react';
import {
  RailsBlock,
  RailsTile,
  RailsTileVersion,
} from '@sls-react/typings/services/rails/tile';
import classNames from 'classnames';
import A from '@sls-react/components/Links/A';
import useMobile from '@sls-react/hooks/useMobile';
import RegisterLink from '@sls-react/components/Links/RegisterLink';
import EmailLoginButton from '@sls-react/components/LoginRegister/EmailLoginButton';
import FacebookButton from '@sls-react/components/LoginRegister/FacebookButton';
import IosAppStoreLink from '@sls-react/components/Links/IosAppStoreLink';
import Image from '@sls-react/components/Image';
import Stars from '@sls-react/static/svg/Stars';
import PlayStoreIcon from '@sls-react/static/svg/PlayStoreIcon';
import GooglePlayStoreLink from '@sls-react/components/Links/GooglePlayStoreLink';
import { useSession } from '@sls-react/contexts/SessionContext';
import { Button } from '@sls-react/components/Form/Button';
import EmpowerAthletes from '@sls-react/components/Homepage/EmpowerAthletes';
import FacebookLoginButton from '@sls-react/components/LoginRegister/FacebookLoginButton';
import IOS_APP_STORE from '@sls-react/static/ios-app-store.png';

interface Props {
  block: RailsBlock;
  tile: RailsTile;
  version?: RailsTileVersion;
}

const HomepageEmpowerHero: React.FC<Props> = ({ block, tile, version }) => {
  const { loggedIn } = useSession();
  const mobile = useMobile();

  return (
    <div
      className={classNames(
        'container flex px-12 md:px-4 pt-4 pb-8 md:py-12',
        version?.halignment === 'left'
          ? 'text-left justify-start'
          : version?.halignment === 'center'
          ? 'text-center justify-center'
          : version?.halignment === 'right'
          ? 'justify-end'
          : '',
      )}
      css={`
        min-height: 300px;
        @media (min-width: 767px) {
          min-height: 500px;
        }
      `}
    >
      <div
        className="flex flex-col justify-center"
        css={`
          z-index: 1;
        `}
      >
        <A
          href={tile.destination}
          css={`
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background: transparent;
          `}
        />
        <h1 className="text-2xl font-semibold leading-none text-center text-white md:mb-4 md:text-4xl md:text-left">
          WE EMPOWER
          <br />
          ATHLETES
        </h1>

        {typeof window !== 'undefined' && <EmpowerAthletes />}

        {loggedIn ? (
          version?.button_text ? (
            <A
              href={tile.destination}
              className={mobile ? 'relative block mb-4' : ''}
            >
              <Button
                className="w-full"
                css={`
                  background-color: ${version?.button_color || '#02c874'};
                  border-color: ${version?.button_color || '#02c874'};
                `}
              >
                {version?.button_text}
              </Button>
            </A>
          ) : null
        ) : (
          <div className="flex flex-col mb-4 md:flex-row md:space-x-4">
            <RegisterLink
              className="relative mb-4 md:mb-0"
              modalProps={{ defaultView: 'registerForm' }}
            >
              <EmailLoginButton text="JOIN WITH EMAIL" />
            </RegisterLink>

            <FacebookLoginButton text="JOIN WITH FACEBOOK" />
          </div>
        )}

        <div className="flex items-center space-x-4">
          <IosAppStoreLink source="homepage" className="relative">
            <Image
              className="inline-block"
              height={32}
              width={100}
              src={IOS_APP_STORE}
              alt="iOS App Store"
            />
          </IosAppStoreLink>

          <GooglePlayStoreLink className="relative inline-flex">
            <PlayStoreIcon height={32} width={106} />
          </GooglePlayStoreLink>

          <div className="flex flex-col text-center">
            <Stars className="mb-1" />
            <div
              className="text-xs"
              css={`
                color: ${version?.text_color || '#fff'};
              `}
            >
              18k+ Ratings
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomepageEmpowerHero;
